import { ValidatorResult } from "~/components/card_details_form";
import { config } from "~/data/config";

export const onecardCardValidator = (cardNumber: string): ValidatorResult => {
  const cleanNumber = cardNumber.replace(/\s/g, "");

  const bins = [
    "421389",
    "418212",
    "471227",
    "402275",
    "523435",
    "40622900",
    "44136428",
    "652955",
    "652994",
    "652950",
    "652992",
    "653032",
    "652999",
    "65309725",
  ];


  // if (config.env === "Staging") {
  //   // no validation for staging
  //   return { isValid: true };
  // }

  if (cleanNumber.length < 6) {
    return { isValid: true };
  }

  const matchesAnyBin = bins.some(
    (bin) => cleanNumber.startsWith(bin) || bin.startsWith(cleanNumber)
  );

  if (!matchesAnyBin) {
    return {
      isValid: false,
      errorMessage: "Please use your OneCard credit card to avail this offer",
    };
  }

  return { isValid: true };
};
